import React from 'react';
import { API_BASE_URL } from '../../../services/api';

export const MediaPreview = ({ type, url, msg }) => {
  if (!url) return null;

  // Ensure url is absolute if it's stored as a relative path
  const fullUrl = url.startsWith('http') 
    ? url 
    : API_BASE_URL + url;
  
  if (type === 'image') {
    return (
      <a href={fullUrl} target="_blank" rel="noopener noreferrer" className="block mt-1 mb-2">
        <img 
          src={fullUrl} 
          alt="Media" 
          className="rounded-lg max-h-64 max-w-full object-contain shadow-sm border border-gray-100 hover:opacity-95 transition-opacity bg-gray-50" 
        />
      </a>
    );
  }

  if (type === 'video') {
    return (
      <div className="mt-1 mb-2 bg-black rounded-lg overflow-hidden border border-gray-100 shadow-sm">
        <video controls className="max-h-64 max-w-full object-contain w-full">
          <source src={fullUrl} />
          Your browser does not support the video tag.
        </video>
      </div>
    );
  }

  if (type === 'audio') {
    return (
      <div className="mt-1 mb-2">
        <audio controls className="max-w-[240px] h-10 outline-none">
          <source src={fullUrl} />
          Your browser does not support the audio element.
        </audio>
      </div>
    );
  }

  // Document or unknown types
  const fileName = msg?.fileName || 'Document Attached';
  const fileSize = msg?.fileSize ? (msg.fileSize / 1024).toFixed(1) + ' KB' : '';

  return (
    <a 
      href={fullUrl} 
      target="_blank" 
      rel="noopener noreferrer" 
      className="flex items-center gap-3 bg-white border border-gray-200 p-3 rounded-lg hover:bg-gray-50 transition-colors shadow-sm mt-1 mb-2 max-w-[280px] group"
    >
      <div className="w-10 h-10 bg-red-50 text-red-500 rounded-md flex-shrink-0 flex items-center justify-center group-hover:bg-red-100 transition-colors">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      </div>
      <div className="flex-1 min-w-0 overflow-hidden">
        <p className="text-sm font-medium text-gray-800 truncate" title={fileName}>{fileName}</p>
        <p className="text-xs text-gray-500 hover:text-purple-600 truncate transition-colors">
          {fileSize ? `${fileSize} • Click to open` : 'Click to open'}
        </p>
      </div>
    </a>
  );
};
